import request from './request'

export function fetchAgreementDeliveryProductList (pageIndex = 1) {
  return request({
    method: 'get',
    url: '/access/v1/risk/agreement/delivery/product/list',
  })
}

export function postAgreementDelivery (data) {
  return request({
    method: 'post',
    url: '/access/v1/ls/risk/agreement/delivery',
    data
  })
}

export function fetchAgreementDeliveryTicket () {
  return request({
    method: 'post',
    url: '/access/v1/ls/account/other/ticket',
    params: {
      type: '1'
    }
  })
}
